import { render, staticRenderFns } from "./timeclock_board.vue?vue&type=template&id=7c696068&"
import script from "./timeclock_board.vue?vue&type=script&lang=js&"
export * from "./timeclock_board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports